import type { Film } from "@/types/film";

export const films: Film[] = [
  {
    id: "silent-boundary",
    title: "沉默的边界",
    titleEn: "The Silent Boundary",
    type: "movie",
    year: 2023,
    region: "美国",
    genres: ["剧情", "家庭"],
    tags: ["婚姻", "秘密", "抉择", "克制"],
    rating: 8.7,
    duration: "128 分钟",
    director: "艾琳·卡特",
    cast: ["诺亚·布莱克", "玛戈·莱恩", "朱利安·福特", "海伦·摩尔"],
    synopsis: "一对结婚十五年的夫妻，在一场意外后被迫重新审视彼此从未说出口的秘密。",
    overview:
      "建筑师丹尼尔与画廊策展人艾丽丝维持着一段看似完美的婚姻。一次深夜的意外电话，让埋藏多年的沉默契约逐渐浮出水面。当真相一层层被揭开，两人必须在诚实与体面之间做出选择。影片以极简的对话和大量留白，追问一个尖锐的伦理命题：善意的隐瞒，究竟是一种保护，还是另一种伤害。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20art%20house%20movie%20poster%2C%20a%20lone%20woman%20standing%20before%20a%20vast%20rain%20streaked%20window%2C%20moody%20dramatic%20chiaroscuro%20lighting%2C%20deep%20blue%20and%20warm%20amber%20tones%2C%20elegant%20negative%20space%2C%20subtle%20film%20grain%2C%20refined%20editorial%20composition%2C%20no%20text&width=600&height=900&seq=film-poster-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%2C%20a%20quiet%20modern%20apartment%20interior%20at%20night%20with%20a%20figure%20gazing%20through%20a%20rain%20streaked%20window%2C%20moody%20deep%20blue%20shadows%20with%20warm%20amber%20lamplight%2C%20dramatic%20atmosphere%2C%20subtle%20film%20grain%2C%20no%20text&width=1600&height=900&seq=film-backdrop-01&orientation=landscape",
    reviewsCount: 1284,
    popularity: 96,
    topicIds: ["marriage", "silence"],
  },
  {
    id: "second-truth",
    title: "第二种真相",
    titleEn: "The Second Truth",
    type: "movie",
    year: 2021,
    region: "英国",
    genres: ["剧情", "悬疑"],
    tags: ["真相", "记忆", "道德困境", "反转"],
    rating: 8.4,
    duration: "116 分钟",
    director: "奥利弗·格兰特",
    cast: ["利亚姆·哈特", "索菲亚·布朗", "丹尼尔·基恩"],
    synopsis: "一场车祸的两种说法，让两个家庭在法庭外展开了另一种审判。",
    overview:
      "记者托马斯因一次调查报道卷入一场车祸真相的争论。当官方结论与他在场的所见互相矛盾，他发现所谓客观的「事实」其实由无数立场拼接而成。影片在庭审、回忆与当下三条时间线之间穿梭，让观众不得不面对一个令人不安的问题：如果每个人记忆里的真相都不同，那么正义该以谁的版本为准。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20art%20house%20movie%20poster%2C%20two%20overlapping%20male%20profiles%20facing%20away%20from%20each%20other%2C%20moody%20dramatic%20chiaroscuro%20lighting%2C%20deep%20blue%20and%20warm%20amber%20tones%2C%20elegant%20negative%20space%2C%20subtle%20film%20grain%2C%20refined%20editorial%20composition%2C%20no%20text&width=600&height=900&seq=film-poster-02&orientation=portrait",
    reviewsCount: 962,
    popularity: 88,
    topicIds: ["court", "silence"],
  },
  {
    id: "testimony-day-night",
    title: "昼与夜的证词",
    titleEn: "Testimony of Day and Night",
    type: "tv",
    year: 2022,
    region: "美国",
    genres: ["剧情", "法庭"],
    tags: ["律政", "证人", "良知", "群像"],
    rating: 9.1,
    duration: "全 10 集",
    director: "瑞贝卡·肖",
    cast: ["凯文·道森", "安娜·里维斯", "马库斯·李", "格蕾丝·陈"],
    synopsis: "一名公设辩护律师在替被社会唾弃的当事人辩护时，逐渐动摇了自己的道德底线。",
    overview:
      "本剧跟随公设辩护律师凯文的日常，他接手的每一个案件都逼迫他在职业责任与个人信念之间权衡。当一位他深信有罪的当事人成为其辩护对象，凯文必须在「人人有权获得辩护」与「为恶者辩护是否等于共谋」之间给出自己的答案。剧集以冷峻的镜头语言，呈现法律与良知之间那条模糊的界线。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20art%20house%20movie%20poster%2C%20a%20figure%20split%20by%20a%20harsh%20beam%20of%20light%20and%20deep%20shadow%2C%20moody%20dramatic%20chiaroscuro%20lighting%2C%20deep%20blue%20and%20warm%20amber%20tones%2C%20elegant%20negative%20space%2C%20subtle%20film%20grain%2C%20refined%20editorial%20composition%2C%20no%20text&width=600&height=900&seq=film-poster-03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%2C%20an%20empty%20courtroom%20bathed%20in%20cold%20window%20light%20with%20a%20single%20seated%20figure%2C%20moody%20deep%20blue%20tones%20with%20amber%20highlights%2C%20dramatic%20atmosphere%2C%20subtle%20film%20grain%2C%20no%20text&width=1600&height=900&seq=film-backdrop-03&orientation=landscape",
    reviewsCount: 2140,
    popularity: 99,
    topicIds: ["court"],
  },
  {
    id: "empty-room",
    title: "无人的房间",
    titleEn: "The Empty Room",
    type: "movie",
    year: 2019,
    region: "法国",
    genres: ["剧情", "悬疑"],
    tags: ["孤独", "遗产", "记忆", "缓慢"],
    rating: 7.8,
    duration: "104 分钟",
    director: "克莱尔·杜邦",
    cast: ["路易·莫罗", "艾曼纽·佩兰", "让·雷诺", "卡米耶·罗"],
    synopsis: "一对兄妹回到童年故居处理遗产，却在一间从不上锁的空房里发现了父亲的另一面。",
    overview:
      "母亲去世后，兄妹二人回到乡下的老宅。整理遗物时，他们发现一间始终空着、却被打扫得一尘不染的房间。随着旧照片与信件被翻出，父亲当年那个从未被家人知晓的选择逐渐清晰。影片用近乎静止的长镜头，讲述一个关于原谅与理解是否可能的故事。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20art%20house%20movie%20poster%2C%20a%20single%20empty%20wooden%20chair%20in%20a%20dim%20abandoned%20room%2C%20moody%20dramatic%20chiaroscuro%20lighting%2C%20deep%20blue%20and%20warm%20amber%20tones%2C%20elegant%20negative%20space%2C%20subtle%20film%20grain%2C%20refined%20editorial%20composition%2C%20no%20text&width=600&height=900&seq=film-poster-04&orientation=portrait",
    reviewsCount: 623,
    popularity: 71,
    topicIds: ["silence"],
  },
  {
    id: "choice-among-ashes",
    title: "灰烬中的选择",
    titleEn: "A Choice Among Ashes",
    type: "tv",
    year: 2023,
    region: "德国",
    genres: ["剧情", "惊悚"],
    tags: ["战争", "良心", "责任", "群像"],
    rating: 8.9,
    duration: "全 8 集",
    director: "汉娜·施密特",
    cast: ["卢卡斯·贝格", "玛丽·克鲁格", "菲利克斯·诺伊曼"],
    synopsis: "战后重建年代，一名档案管理员在整理旧卷宗时，发现了足以摧毁几位「英雄」的证据。",
    overview:
      "故事发生在战后重建的十年间。档案管理员莉娜被指派整理一批尘封的市政卷宗，却在其中读到一个被官方叙事刻意抹去的名字。当她把线索一个个拼合，她意识到自己掌握的不是一段往事，而是一整座城市赖以自傲的谎言的根基。沉默，还是发声，成为她必须承担的重量。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20art%20house%20movie%20poster%2C%20a%20hand%20reaching%20through%20drifting%20smoke%20and%20embers%2C%20moody%20dramatic%20chiaroscuro%20lighting%2C%20deep%20blue%20and%20warm%20amber%20tones%2C%20elegant%20negative%20space%2C%20subtle%20film%20grain%2C%20refined%20editorial%20composition%2C%20no%20text&width=600&height=900&seq=film-poster-05&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%2C%20an%20archive%20room%20filled%20with%20towering%20old%20files%20and%20a%20figure%20holding%20a%20lamp%2C%20moody%20deep%20blue%20shadows%20with%20warm%20amber%20glow%2C%20dramatic%20atmosphere%2C%20subtle%20film%20grain%2C%20no%20text&width=1600&height=900&seq=film-backdrop-05&orientation=landscape",
    reviewsCount: 1560,
    popularity: 94,
    topicIds: ["silence", "court"],
  },
  {
    id: "quiet-pact",
    title: "静默契约",
    titleEn: "The Quiet Pact",
    type: "movie",
    year: 2020,
    region: "美国",
    genres: ["剧情", "家庭"],
    tags: ["承诺", "亲情", "牺牲", "隐忍"],
    rating: 8.1,
    duration: "110 分钟",
    director: "丹尼尔·佩里",
    cast: ["伊森·柯尔", "露西亚·纳瓦罗", "奥黛丽·怀特"],
    synopsis: "为了让患病的弟弟完成学业，哥哥隐瞒了一个足以改变全家命运的决定。",
    overview:
      "在小城经营修理铺的哥哥，为了供弟弟完成大学，悄悄卖掉父亲留下的房子，并对外宣称一切如常。当弟弟意外发现真相，两人的关系在愧疚与感激之间剧烈摇摆。影片细腻地描绘了亲情里那种「不说出口的爱」，以及它可能带来的代价。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20art%20house%20movie%20poster%2C%20two%20hands%20almost%20touching%20across%20a%20dark%20table%2C%20moody%20dramatic%20chiaroscuro%20lighting%2C%20deep%20blue%20and%20warm%20amber%20tones%2C%20elegant%20negative%20space%2C%20subtle%20film%20grain%2C%20refined%20editorial%20composition%2C%20no%20text&width=600&height=900&seq=film-poster-06&orientation=portrait",
    reviewsCount: 744,
    popularity: 76,
    topicIds: ["marriage", "silence"],
  },
  {
    id: "judgment-by-the-sea",
    title: "海边的审判",
    titleEn: "Judgment by the Sea",
    type: "movie",
    year: 2022,
    region: "西班牙",
    genres: ["剧情", "悬疑"],
    tags: ["小镇", "舆论", "偏见", "真相"],
    rating: 8.0,
    duration: "118 分钟",
    director: "保罗·门德斯",
    cast: ["安赫尔·鲁伊斯", "克拉拉·维加", "迭戈·桑托斯"],
    synopsis: "一座靠海小镇因一起沉船事故陷入相互指认，真相被潮水一次次冲上岸又带走。",
    overview:
      "一艘载着非法移民的船在小镇附近倾覆，救援的迟缓让舆论迅速发酵。渔民、警长、记者与幸存者各执一词，每个人都想证明自己清白。影片以一个封闭的小镇为舞台，把「集体沉默」与「个体良心」放在同一片海水里浸泡。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20art%20house%20movie%20poster%2C%20a%20lone%20figure%20standing%20on%20a%20stormy%20grey%20beach%2C%20moody%20dramatic%20chiaroscuro%20lighting%2C%20deep%20blue%20and%20warm%20amber%20tones%2C%20elegant%20negative%20space%2C%20subtle%20film%20grain%2C%20refined%20editorial%20composition%2C%20no%20text&width=600&height=900&seq=film-poster-07&orientation=portrait",
    reviewsCount: 508,
    popularity: 69,
    topicIds: ["court"],
  },
  {
    id: "two-faced-mirror",
    title: "双面镜像",
    titleEn: "Two-Faced Mirror",
    type: "tv",
    year: 2021,
    region: "英国",
    genres: ["剧情", "悬疑"],
    tags: ["身份", "双面", "谎言", "都市"],
    rating: 8.5,
    duration: "全 12 集",
    director: "艾米丽·沃德",
    cast: ["詹姆斯·布莱克", "奥利维亚·格林", "托马斯·昆"],
    synopsis: "一位受人尊敬的医生，在白天的医院与夜晚的地下诊所里，过着两种截然不同的人生。",
    overview:
      "白天，他是医院里最值得信赖的外科医生；夜晚，他在一间无名诊所里，为那些无法踏入正规医院的人做手术。当一名患者死在他的地下诊所，两条人生线开始剧烈碰撞。剧集用镜像般的双线叙事，追问：一个人的善行，能否抵消他的越界。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20art%20house%20movie%20poster%2C%20a%20broken%20mirror%20reflecting%20a%20fragmented%20silhouette%2C%20moody%20dramatic%20chiaroscuro%20lighting%2C%20deep%20blue%20and%20warm%20amber%20tones%2C%20elegant%20negative%20space%2C%20subtle%20film%20grain%2C%20refined%20editorial%20composition%2C%20no%20text&width=600&height=900&seq=film-poster-08&orientation=portrait",
    reviewsCount: 1188,
    popularity: 85,
    topicIds: ["city", "court"],
  },
  {
    id: "borrowed-time",
    title: "借来的时间",
    titleEn: "Borrowed Time",
    type: "movie",
    year: 2018,
    region: "加拿大",
    genres: ["剧情", "爱情"],
    tags: ["临终", "陪伴", "宽恕", "温柔"],
    rating: 8.3,
    duration: "98 分钟",
    director: "莎拉·勒克莱尔",
    cast: ["马克·特朗布莱", "朱莉·勒布朗", "亚历山大·罗伊"],
    synopsis: "一位临终关怀护士，在照顾最后一位病人时，被迫面对自己十年前的一个决定。",
    overview:
      "护士玛侬把二十年献给了临终病房。当她接手的最后一位病人，竟是当年导致她女儿离世那场事故的司机，职业的温柔与私人的怨恨在她心里同时燃烧。影片安静而克制，讲述时间如何既不能治愈一切，也不能带走过往。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20art%20house%20movie%20poster%2C%20a%20vintage%20clock%20beside%20a%20seated%20silhouette%2C%20moody%20dramatic%20chiaroscuro%20lighting%2C%20deep%20blue%20and%20warm%20amber%20tones%2C%20elegant%20negative%20space%2C%20subtle%20film%20grain%2C%20refined%20editorial%20composition%2C%20no%20text&width=600&height=900&seq=film-poster-09&orientation=portrait",
    reviewsCount: 432,
    popularity: 66,
    topicIds: ["silence"],
  },
  {
    id: "edge-of-sin",
    title: "罪与恕的边缘",
    titleEn: "Edge of Sin and Grace",
    type: "tv",
    year: 2023,
    region: "美国",
    genres: ["剧情", "惊悚"],
    tags: ["赎罪", "信仰", "救赎", "群像"],
    rating: 8.8,
    duration: "全 9 集",
    director: "玛莎·李",
    cast: ["安德鲁·皮尔斯", "娜奥米·凯恩", "塞缪尔·里德"],
    synopsis: "一座小城接连发生忏悔室里的秘密泄露事件，神父必须在自己也会被审判的前提下做出选择。",
    overview:
      "老神父约翰听了几十年忏悔，却从未像此刻这样为难：他掌握的秘密，可能救下一个人，也可能毁掉更多人。当法律的手伸进教堂，当信众开始互相怀疑，约翰必须在守密与救人之间反复掂量。剧集把宗教伦理与世俗正义放在同一天平上。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20art%20house%20movie%20poster%2C%20a%20kneeling%20figure%20bathed%20in%20a%20single%20shaft%20of%20light%2C%20moody%20dramatic%20chiaroscuro%20lighting%2C%20deep%20blue%20and%20warm%20amber%20tones%2C%20elegant%20negative%20space%2C%20subtle%20film%20grain%2C%20refined%20editorial%20composition%2C%20no%20text&width=600&height=900&seq=film-poster-10&orientation=portrait",
    reviewsCount: 1730,
    popularity: 92,
    topicIds: ["silence", "court"],
  },
  {
    id: "vows-in-the-rain",
    title: "雨中的誓言",
    titleEn: "Vows in the Rain",
    type: "movie",
    year: 2024,
    region: "美国",
    genres: ["剧情", "爱情"],
    tags: ["婚礼", "承诺", "背叛", "抉择"],
    rating: 8.2,
    duration: "112 分钟",
    director: "格蕾丝·奥康纳",
    cast: ["利亚姆·诺兰", "艾拉·摩根", "本·卡特"],
    synopsis: "婚礼前夜的一场暴雨，让准新娘不得不在一段旧情与一个承诺之间做出最后的决定。",
    overview:
      "婚礼前夜，暴雨困住了整座城市。准新娘艾拉收到一封迟到多年的信，写信的人正是那个她以为早已放下的人。二十四小时之内，她要在两个未来之间选择其一，而无论选择哪个，都会有人受伤。影片把一场婚礼拍成了一次关于承诺真正含义的追问。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20art%20house%20movie%20poster%2C%20a%20couple%20standing%20under%20heavy%20rain%20at%20night%2C%20moody%20dramatic%20chiaroscuro%20lighting%2C%20deep%20blue%20and%20warm%20amber%20tones%2C%20elegant%20negative%20space%2C%20subtle%20film%20grain%2C%20refined%20editorial%20composition%2C%20no%20text&width=600&height=900&seq=film-poster-11&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%2C%20two%20figures%20standing%20apart%20in%20heavy%20rain%20on%20a%20city%20street%20at%20night%2C%20deep%20blue%20tones%20with%20warm%20amber%20streetlight%20bokeh%2C%20dramatic%20atmosphere%2C%20subtle%20film%20grain%2C%20no%20text&width=1600&height=900&seq=film-backdrop-11&orientation=landscape",
    reviewsCount: 990,
    popularity: 87,
    topicIds: ["marriage", "city"],
  },
  {
    id: "north-south-pact",
    title: "南北契约",
    titleEn: "The North-South Pact",
    type: "tv",
    year: 2020,
    region: "英国",
    genres: ["剧情", "家庭"],
    tags: ["家族", "利益", "继承", "对峙"],
    rating: 7.9,
    duration: "全 6 集",
    director: "亨利·阿什福德",
    cast: ["威廉·格兰特", "比阿特丽斯·霍尔", "爱德华·里斯"],
    synopsis: "一个家族企业分崩离析之际，一纸旧契约把两代人的恩怨重新摆上谈判桌。",
    overview:
      "北方的工厂与南方的总部，本是一体。当老掌门病重，一份签于三十年前的契约被重新翻出，两个分支家族不得不重新分配权力与债务。谈判桌上的每一次让步，都牵扯出更早的亏欠。剧集以家族为切口，讨论利益与情义孰轻孰重。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20art%20house%20movie%20poster%2C%20two%20figures%20facing%20each%20other%20across%20a%20long%20table%2C%20moody%20dramatic%20chiaroscuro%20lighting%2C%20deep%20blue%20and%20warm%20amber%20tones%2C%20elegant%20negative%20space%2C%20subtle%20film%20grain%2C%20refined%20editorial%20composition%2C%20no%20text&width=600&height=900&seq=film-poster-12&orientation=portrait",
    reviewsCount: 386,
    popularity: 62,
    topicIds: ["court", "marriage"],
  },
  {
    id: "last-witness",
    title: "最后一位证人",
    titleEn: "The Last Witness",
    type: "movie",
    year: 2023,
    region: "德国",
    genres: ["剧情", "法庭"],
    tags: ["证人保护", "恐惧", "勇气", "孤证"],
    rating: 8.6,
    duration: "124 分钟",
    director: "克劳斯·里希特",
    cast: ["马蒂亚斯·沃尔夫", "莉娜·霍夫曼", "奥托·布劳恩"],
    synopsis: "一桩旧案唯一的证人决定出庭，却发现要对抗的不只是被告，还有整条时间线。",
    overview:
      "二十年前的一桩命案早已结案，唯一的目击者在多年后决定推翻自己当年的证词。出庭意味着翻案，也意味着她必须承认自己曾经撒了谎。影片以证人的视角，呈现一个人如何与自己的过去对簿公堂，以及正义迟到时是否还算正义。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20art%20house%20movie%20poster%2C%20a%20figure%20standing%20in%20a%20bright%20witness%20box%2C%20moody%20dramatic%20chiaroscuro%20lighting%2C%20deep%20blue%20and%20warm%20amber%20tones%2C%20elegant%20negative%20space%2C%20subtle%20film%20grain%2C%20refined%20editorial%20composition%2C%20no%20text&width=600&height=900&seq=film-poster-13&orientation=portrait",
    reviewsCount: 812,
    popularity: 80,
    topicIds: ["court"],
  },
  {
    id: "glass-house-secrets",
    title: "玻璃屋的秘密",
    titleEn: "Secrets of the Glass House",
    type: "tv",
    year: 2019,
    region: "澳大利亚",
    genres: ["剧情", "悬疑"],
    tags: ["透明", "监控", "隐私", "社区"],
    rating: 7.7,
    duration: "全 8 集",
    director: "艾莉森·里德",
    cast: ["山姆·哈里斯", "菲奥娜·克拉克", "杰克·汤普森"],
    synopsis: "一个崇尚「完全透明」的现代社区里，隐私成了最奢侈的东西，也成了最大的武器。",
    overview:
      "海边的实验社区以「无秘密」为信条，住户的房屋全部是玻璃结构，公共区域布满摄像头。新搬来的纪录片导演很快发现，越是透明的地方，越适合藏东西。当一桩失踪案发生，每个人都在镜头下表演，而真相躲在镜头之外。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20art%20house%20movie%20poster%2C%20a%20modern%20glass%20house%20glowing%20at%20dusk%2C%20moody%20dramatic%20chiaroscuro%20lighting%2C%20deep%20blue%20and%20warm%20amber%20tones%2C%20elegant%20negative%20space%2C%20subtle%20film%20grain%2C%20refined%20editorial%20composition%2C%20no%20text&width=600&height=900&seq=film-poster-14&orientation=portrait",
    reviewsCount: 344,
    popularity: 58,
    topicIds: ["city"],
  },
  {
    id: "midnight-call",
    title: "午夜来电",
    titleEn: "The Midnight Call",
    type: "movie",
    year: 2024,
    region: "法国",
    genres: ["剧情", "惊悚"],
    tags: ["悬案", "对话", "道德", "紧绷"],
    rating: 8.4,
    duration: "96 分钟",
    director: "娜塔莉·纪尧姆",
    cast: ["文森特·杜兰", "伊莎贝尔·佩兰", "皮埃尔·洛朗"],
    synopsis: "一通打给电台的午夜电话，让主持人被迫在直播中成为一个陌生人生死抉择的见证者。",
    overview:
      "深夜电台主持人接到一个自称要结束生命的来电。为了留住对方，他打破所有职业规范，把直播变成一场漫长的对话。随着电话内容逐渐失控，主持人发现自己也被卷入了对方故事里那个不该被触碰的部分。影片几乎全在一间直播间里展开。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20art%20house%20movie%20poster%2C%20a%20person%20holding%20a%20phone%20in%20a%20dark%20hallway%2C%20moody%20dramatic%20chiaroscuro%20lighting%2C%20deep%20blue%20and%20warm%20amber%20tones%2C%20elegant%20negative%20space%2C%20subtle%20film%20grain%2C%20refined%20editorial%20composition%2C%20no%20text&width=600&height=900&seq=film-poster-15&orientation=portrait",
    reviewsCount: 660,
    popularity: 78,
    topicIds: ["silence", "city"],
  },
  {
    id: "fragile-love",
    title: "摇摇欲坠的爱",
    titleEn: "Fragile Love",
    type: "tv",
    year: 2022,
    region: "美国",
    genres: ["剧情", "爱情"],
    tags: ["亲密关系", "依赖", "界限", "细腻"],
    rating: 8.1,
    duration: "全 10 集",
    director: "瑞秋·西蒙斯",
    cast: ["亚当·韦斯特", "克洛伊·贝内特", "利亚·布鲁克斯"],
    synopsis: "一段看似稳固的婚姻里，两个人都在用「为你好」的方式，慢慢夺走对方的呼吸空间。",
    overview:
      "剧集围绕一对都市中产夫妻展开，从旁人艳羡到彼此窒息，只用了一个四季的时间。没有激烈的争吵，只有一次次「我是为你好」的让步，和一点点被蚕食的自我。剧集用近乎纪实的细腻笔触，讨论爱与控制之间那条几乎看不见的线。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20art%20house%20movie%20poster%2C%20two%20abstract%20figures%20leaning%20toward%20each%20other%2C%20moody%20dramatic%20chiaroscuro%20lighting%2C%20deep%20blue%20and%20warm%20amber%20tones%2C%20elegant%20negative%20space%2C%20subtle%20film%20grain%2C%20refined%20editorial%20composition%2C%20no%20text&width=600&height=900&seq=film-poster-16&orientation=portrait",
    reviewsCount: 904,
    popularity: 83,
    topicIds: ["marriage", "city"],
  },
  {
    id: "forgotten-promise",
    title: "被遗忘的承诺",
    titleEn: "The Forgotten Promise",
    type: "movie",
    year: 2021,
    region: "英国",
    genres: ["剧情", "家庭"],
    tags: ["养老", "记忆", "亲情", "遗憾"],
    rating: 8.0,
    duration: "106 分钟",
    director: "乔治·哈灵顿",
    cast: ["迈克尔·卡特", "海伦·布莱克", "保罗·里德"],
    synopsis: "一位患阿尔茨海默症的老人，把一句六十年前没能兑现的承诺，误当成了明天的约会。",
    overview:
      "老人乔治的记忆正在一寸寸退潮，唯独六十年前那个没能赴约的下午愈发清晰。他每天都要「出门赴约」，而女儿只能一遍遍把他接回家。当女儿决定认真对待父亲那份固执，一段被家族掩埋多年的往事被重新打开。影片温柔而克制。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20art%20house%20movie%20poster%2C%20aged%20handwritten%20letters%20and%20resting%20hands%2C%20moody%20dramatic%20chiaroscuro%20lighting%2C%20deep%20blue%20and%20warm%20amber%20tones%2C%20elegant%20negative%20space%2C%20subtle%20film%20grain%2C%20refined%20editorial%20composition%2C%20no%20text&width=600&height=900&seq=film-poster-17&orientation=portrait",
    reviewsCount: 472,
    popularity: 64,
    topicIds: ["silence", "marriage"],
  },
  {
    id: "before-dawn",
    title: "黎明前的抉择",
    titleEn: "Choice Before Dawn",
    type: "tv",
    year: 2024,
    region: "美国",
    genres: ["剧情", "惊悚"],
    tags: ["急诊", "分诊", "资源", "生死"],
    rating: 8.9,
    duration: "全 12 集",
    director: "维罗妮卡·亚当斯",
    cast: ["约书亚·凯恩", "艾米莉亚·罗斯", "内森·福特", "佐伊·格林"],
    synopsis: "一场大规模事故让急诊室资源见底，医生们必须在几分钟内决定：先救谁。",
    overview:
      "一个平常的夜晚被一场连环事故撕开。急诊室里，床位、血浆、手术室全都告急，每一张病床的分配都意味着另一个人的等待。剧集跟随几十位医护的视角，把「分诊」这个冰冷的词还原成一次次撕心裂肺的选择，追问在极端条件下，人还能守住多少善意。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20art%20house%20movie%20poster%2C%20a%20lone%20figure%20at%20a%20dawn%20horizon%20line%2C%20moody%20dramatic%20chiaroscuro%20lighting%2C%20deep%20blue%20and%20warm%20amber%20tones%2C%20elegant%20negative%20space%2C%20subtle%20film%20grain%2C%20refined%20editorial%20composition%2C%20no%20text&width=600&height=900&seq=film-poster-18&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%2C%20a%20hospital%20corridor%20at%20dawn%20with%20a%20lone%20figure%20silhouetted%20against%20large%20windows%2C%20deep%20blue%20tones%20with%20warm%20amber%20strip%20lights%2C%20dramatic%20atmosphere%2C%20subtle%20film%20grain%2C%20no%20text&width=1600&height=900&seq=film-backdrop-18&orientation=landscape",
    reviewsCount: 2380,
    popularity: 98,
    topicIds: ["court", "city"],
  },
];